function svPdpDestroySwiper(el) {
  if (!el || typeof Swiper === "undefined") return;
  const inst = el.swiper;
  if (!inst) return;
  try {
    inst.destroy(true, true);
  } catch (_) {}
}

function svPdpGetAlpineData(el) {
  if (!el || typeof window.Alpine === "undefined") return null;
  try {
    if (typeof Alpine.$data === "function") return Alpine.$data(el);
  } catch (_) {}
  return el._x_dataStack?.[0] ?? null;
}

function svPdpReinitAfterSectionChange(sectionEl) {
  const pdpRoot = sectionEl.querySelector?.(".sv-pdp");
  if (!pdpRoot || typeof Swiper === "undefined") return;

  const rerun = () => {
    const gallery = svPdpGetAlpineData(pdpRoot);
    if (gallery?.init) {
      try {
        gallery.init();
      } catch (_) {}
    }

    const reelsRoot = pdpRoot.querySelector(".sv-pdp__video-reels");
    if (reelsRoot) {
      const reels = svPdpGetAlpineData(reelsRoot);
      if (reels?.initSwiper) {
        try {
          reels.initSwiper();
        } catch (_) {}
      }
    }
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(rerun);
  });
}

function svPdpInitStandaloneVideoReels(sectionEl) {
  if (!sectionEl?.querySelector?.(".sv-pdp__video-reels")) return;
  const rerun = () => {
    sectionEl.querySelectorAll(".sv-pdp__video-reels").forEach((reelsRoot) => {
      const reels = svPdpGetAlpineData(reelsRoot);
      if (reels?.initSwiper) {
        try {
          reels.initSwiper();
        } catch (_) {}
      }
    });
  };
  requestAnimationFrame(() => {
    requestAnimationFrame(rerun);
  });
}

function svPdpMoney(cents) {
  if (typeof cents !== "number" || Number.isNaN(cents)) return "";
  const fmt = window.theme?.moneyFormat || "${{amount}}";
  if (window.theme?.Currency?.formatMoney) {
    return window.theme.Currency.formatMoney(cents, fmt).replaceAll(".00", "");
  }
  return (cents / 100).toFixed(2);
}

function svPdpStickyAtcScrollToBundle(e) {
  const target = document.querySelector("#pdp__bundle-save");
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
}

function svPdpIsBundleComponent(data) {
  return !!(
    data &&
    typeof data.sumBundleSubscribeCents === "function" &&
    typeof data.sumBundleOnetimeCents === "function"
  );
}

function svPdpSyncStickyAtcPrice() {
  const bundleRoot = document.querySelector("#pdp__bundle-save");
  const sticky = document.querySelector(".sticky-atc--container");
  if (!bundleRoot || !sticky) return;
  const priceEl = sticky.querySelector(".sticky-atc__price");
  const compareEl = sticky.querySelector(".sticky-atc__compare");
  if (!priceEl) return;

  const rootData = svPdpGetAlpineData(bundleRoot);
  if (svPdpIsBundleComponent(rootData)) {
    const subscribe = rootData.purchaseMode === "subscribe";
    const priceCents = subscribe
      ? rootData.sumBundleSubscribeCents()
      : rootData.sumBundleOnetimeCents();
    const compareCents = subscribe
      ? rootData.sumBundleSubscribeCompareCents()
      : rootData.sumBundleOnetimeCompareCents();

    priceEl.textContent = rootData.formatMoney(priceCents);
    if (compareEl) {
      const showCompare = compareCents > priceCents;
      compareEl.textContent = rootData.formatMoney(compareCents);
      compareEl.hidden = !showCompare;
    }
    return;
  }

  const formRoot = bundleRoot.closest(".sv-pdp__product-section") || bundleRoot;
  const formData =
    formRoot === bundleRoot ? rootData : svPdpGetAlpineData(formRoot);
  const formatMoney =
    typeof formData?.formatMoney === "function"
      ? formData.formatMoney.bind(formData)
      : svPdpMoney;
  const variant = formData?.currentVariant;
  if (!variant) return;

  const sellingPlanInput = formRoot.querySelector('[name="selling_plan"]');
  const sellingPlanId =
    sellingPlanInput &&
    !sellingPlanInput.disabled &&
    String(sellingPlanInput.value || "").trim()
      ? String(sellingPlanInput.value)
      : "";

  let priceCents = Number(variant.price) || 0;
  let compareCents = Number(variant.compare_at_price) || 0;

  if (sellingPlanId) {
    const alloc = (variant.selling_plan_allocations || []).find(
      (item) => String(item.selling_plan_id) === sellingPlanId,
    );
    if (alloc) {
      priceCents = Number(alloc.price ?? priceCents) || 0;
      const allocCompare = Number(alloc.compare_at_price) || 0;
      if (allocCompare > priceCents) compareCents = allocCompare;
    }
  }

  priceEl.textContent = formatMoney(priceCents);
  if (compareEl) {
    const showCompare = compareCents > priceCents;
    compareEl.textContent = showCompare ? formatMoney(compareCents) : "";
    compareEl.hidden = !showCompare;
  }
}

function svPdpParseTierLabelToCents(label) {
  if (!label || typeof label !== "string") return null;
  const normalized = label.replace(/,/g, ".");
  const m = normalized.match(/(\d+(?:\.\d+)?)/);
  if (!m) return null;
  const n = Number.parseFloat(m[1]);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

function svPdpRefillLabelFromPlanName(name) {
  if (!name || typeof name !== "string") return "";
  const lower = name.trim().toLowerCase();
  let m = lower.match(/every\s+(\d+)\s+(day|days|week|weeks|month|months)/);
  if (!m) m = lower.match(/(\d+)\s+(day|days|week|weeks|month|months)/);
  if (!m) return "";
  const qty = m[1];
  let unit = m[2];
  if (!unit.endsWith("s")) unit += "s";
  return `REFILL EVERY ${qty} ${unit.toUpperCase()}`;
}

function svPdpGalleryToVariantMedia(sectionRoot, variant) {
  if (!variant?.featured_media?.id) return;
  const pdpRoot = sectionRoot.closest(".sv-pdp");
  if (!pdpRoot) return;
  const mediaId = String(variant.featured_media.id);
  const main = pdpRoot.querySelector(".sv-pdp__main-swiper");
  const thumbs = pdpRoot.querySelector(".sv-pdp__thumbs-swiper");
  if (main?.swiper) {
    const slides = [...main.querySelectorAll(".swiper-slide[data-media-id]")];
    const idx = slides.findIndex(
      (s) => s.getAttribute("data-media-id") === mediaId,
    );
    if (idx >= 0) main.swiper.slideTo(idx);
  }
  if (thumbs?.swiper) {
    const tslides = [
      ...thumbs.querySelectorAll(".swiper-slide[data-media-id]"),
    ];
    const tidx = tslides.findIndex(
      (s) => s.getAttribute("data-media-id") === mediaId,
    );
    if (tidx >= 0) thumbs.swiper.slideTo(tidx);
  }
}

document.addEventListener("shopify:section:unload", (event) => {
  const section = event.target;
  if (!section?.querySelectorAll) return;
  section
    .querySelectorAll(
      ".sv-pdp__main-swiper, .sv-pdp__thumbs-swiper, .sv-pdp__video-reels-swiper",
    )
    .forEach(svPdpDestroySwiper);
});

document.addEventListener("shopify:section:load", (event) => {
  const target = event.target;
  if (!target) return;
  if (typeof Alpine !== "undefined" && typeof Alpine.initTree === "function") {
    Alpine.initTree(target);
  }
  if (target.querySelector(".sv-pdp")) {
    svPdpReinitAfterSectionChange(target);
  } else {
    svPdpInitStandaloneVideoReels(target);
  }
});

const SV_PDP_BUNDLE_QTY = "svpdp-bundleqty";
const SV_PDP_BUNDLE_ONETIME_QTY_PCT = [0, 0, 5.01, 10.01];

function svPdpParseTierPctCsv(raw, fallback) {
  const base = Array.isArray(fallback)
    ? fallback.slice(0, 4)
    : [0, 0, 5.01, 10.01];
  const out = base.slice(0, 4);
  if (typeof raw !== "string" || !raw.trim()) return out;
  const parts = raw.split(",");
  for (let i = 0; i < 4; i++) {
    const n = Number.parseFloat(String(parts[i] ?? "").trim());
    if (Number.isFinite(n)) out[i] = n;
  }
  return out;
}

document.addEventListener("alpine:init", () => {
  Alpine.data("svPdpProductForm", (config) => ({
    sectionId: String(config.sectionId ?? ""),
    ajaxEnabled: !!config.ajaxEnabled,
    atcLabel: config.atcLabel != null ? String(config.atcLabel) : "",
    enableHistory: config.enableHistory !== false,
    product: null,
    currentVariant: null,
    purchaseMode: "onetime",
    selectedSellingPlanId: "",
    loading: false,
    errorMessage: "",
    errorVisible: false,
    sellingPlanNameById: {},
    /** Bundle block is present and has a non-empty product list. */
    bundleListActive: false,
    /** Sum of flavor quantities in the bundle list (0 until user adds). */
    bundleListTotal: 0,
    bundleTierSlot: 0,
    bundleTierPriceLabels: Array.isArray(config.bundleTierPriceLabels)
      ? config.bundleTierPriceLabels
      : null,
    _bundleQtyEl: null,
    _bundleQtyHandler: null,

    init() {
      const jsonEl = this.$root.querySelector(`#ProductJson-${this.sectionId}`);
      if (!jsonEl) return;
      try {
        this.product = JSON.parse(jsonEl.textContent);
      } catch (_) {
        return;
      }
      const planNamesEl = this.$root.querySelector(
        `#SvPdpSellingPlanNames-${this.sectionId}`,
      );
      if (planNamesEl) {
        try {
          this.sellingPlanNameById = JSON.parse(planNamesEl.textContent);
        } catch (_) {
          this.sellingPlanNameById = {};
        }
      }
      this.syncCurrentVariant();
      if (!this.currentVariant && this.product.variants?.length) {
        this.currentVariant = this.product.variants[0];
      }
      this.syncVariantInputState();
      this.applyMasterSelect();
      this.selectedSellingPlanId = this.pickDefaultPlanId();
      this.$watch("currentVariant", () => this.onCurrentVariantWatch());
      this.$watch("purchaseMode", () => this.normalizePlanSelection());
      this.$watch("bundleListTotal", () => this.syncBundleTierSlot());
      this.onCurrentVariantWatch();

      this._bundleQtyEl = this.$root.closest?.(".sv-pdp__info");
      this._bundleQtyHandler = () => {
        const br = this._bundleQtyEl?.querySelector(".sv-pdp__bundle-save");
        const b = br ? svPdpGetAlpineData(br) : null;
        this.bundleListTotal = b?.totalQty?.() ?? 0;
        this.bundleListActive = (b?.products || []).length > 0;
        svPdpSyncStickyAtcPrice();
      };
      if (this._bundleQtyEl) {
        this._bundleQtyEl.addEventListener(
          SV_PDP_BUNDLE_QTY,
          this._bundleQtyHandler,
        );
        const syncBundleQtyFromBlock = () => {
          const br = this._bundleQtyEl.querySelector(".sv-pdp__bundle-save");
          const b = br ? svPdpGetAlpineData(br) : null;
          if (b) {
            this.bundleListActive = (b.products || []).length > 0;
            this.bundleListTotal = b.totalQty();
          }
        };
        syncBundleQtyFromBlock();
        this.$nextTick(() => syncBundleQtyFromBlock());
      }
      this.syncBundleTierSlot();
      this.stickyAtcBar();

      this._skioUpdateHandler = (event) => {
        if (!this.$root.contains(event.target)) return;
        svPdpSyncStickyAtcPrice();
      };
      document.addEventListener("skio::update-selling-plan", this._skioUpdateHandler);
    },

    stickyAtcBar() {
      const stickyContainer = document.querySelector('.sticky-atc--container');
      const buyBox = document.querySelector('#pdp__bundle-save');
      const stickyBtn = stickyContainer?.querySelector('.sticky-atc__btn');

      svPdpSyncStickyAtcPrice();

      if (stickyBtn && buyBox && !stickyBtn.dataset.svPdpScrollBound) {
        stickyBtn.dataset.svPdpScrollBound = '1';
        stickyBtn.addEventListener('click', svPdpStickyAtcScrollToBundle);
      }

      window.addEventListener('scroll', () => {
        if (!stickyContainer || !buyBox) return;

        const buyBoxBottom = buyBox.getBoundingClientRect().bottom + window.scrollY;
        if (window.scrollY > buyBoxBottom) {
          stickyContainer.classList.add('visible');
        } 
        else {
          stickyContainer.classList.remove('visible');
        }
      });      
    },

    onCurrentVariantWatch() {
      this.syncVariantInputState();
      const form = this.$root.querySelector("[data-product-form]");
      if (form && !this.bundleListActive) {
        form.classList.toggle(
          "product-form--variant-sold-out",
          !this.currentVariant?.available,
        );
      }
      if (this.purchaseMode === "subscribe" && !this.canSubscribe) {
        this.purchaseMode = "onetime";
      }
      this.normalizePlanSelection();
      svPdpGalleryToVariantMedia(this.$root, this.currentVariant);
      svPdpSyncStickyAtcPrice();
      requestAnimationFrame(() => svPdpSyncStickyAtcPrice());
    },

    get canSubscribe() {
      return (this.currentVariant?.selling_plan_allocations?.length || 0) > 0;
    },

    pickDefaultPlanId() {
      const a = this.currentVariant?.selling_plan_allocations?.[0];
      return a != null ? String(a.selling_plan_id) : "";
    },

    normalizePlanSelection() {
      const allocs = this.currentVariant?.selling_plan_allocations || [];
      if (!allocs.length) {
        this.selectedSellingPlanId = "";
        return;
      }
      const ok = allocs.some(
        (a) => String(a.selling_plan_id) === String(this.selectedSellingPlanId),
      );
      if (!ok) this.selectedSellingPlanId = String(allocs[0].selling_plan_id);
    },

    formatMoney(cents) {
      return svPdpMoney(Number(cents) || 0);
    },

    planLabel(alloc) {
      const id =
        alloc?.selling_plan_id != null
          ? String(alloc.selling_plan_id)
          : "";
      if (id && this.sellingPlanNameById && this.sellingPlanNameById[id]) {
        return this.sellingPlanNameById[id];
      }
      const p = alloc.selling_plan;
      return p?.name || p?.options?.[0]?.value || "Subscription";
    },

    subscribeRefillLabel() {
      const id = String(this.selectedSellingPlanId || "");
      if (!id) return "";
      const name = this.sellingPlanNameById?.[id];
      if (name) return svPdpRefillLabelFromPlanName(name);
      const alloc = (this.currentVariant?.selling_plan_allocations || []).find(
        (a) => String(a.selling_plan_id) === id,
      );
      return svPdpRefillLabelFromPlanName(this.planLabel(alloc));
    },

    pillSelected(optionIndex, value) {
      const sel = this.$root.querySelector(
        `#SingleOptionSelector-${this.sectionId}-${optionIndex}`,
      );
      return !!(sel && sel.value === value);
    },

    syncVariantInputState() {
      const optionCount = this.product?.options?.length || 0;
      for (let i = 0; i < optionCount; i++) {
        const selectedValue =
          this.$root.querySelector(
            `#SingleOptionSelector-${this.sectionId}-${i}`,
          )?.value ?? this.currentVariant?.options?.[i];
        const radios = this.$root.querySelectorAll(
          `.sv-pdp__variant-radio[name="sv-pdp-option-${i + 1}"]`,
        );

        radios.forEach((radio) => {
          const isSelected = String(radio.value) === String(selectedValue);
          radio.checked = isSelected;

          const swatch = radio.nextElementSibling;
          if (swatch?.classList) {
            swatch.classList.toggle("is-selected", isSelected);
          }
        });
      }
    },

    setOption(optionIndex, value) {
      const sel = this.$root.querySelector(
        `#SingleOptionSelector-${this.sectionId}-${optionIndex}`,
      );
      if (sel) {
        sel.value = value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this.syncCurrentVariant();
      this.applyMasterSelect(true);
      this.updateHistory();
      this.normalizePlanSelection();
      this.syncVariantInputState();
    },

    syncSelectorsFromCheckedRadios() {
      const n = this.product?.options?.length || 0;
      for (let i = 0; i < n; i++) {
        const checked = this.$root.querySelector(
          `.sv-pdp__variant-radio[name="sv-pdp-option-${i + 1}"]:checked`,
        );
        const sel = this.$root.querySelector(
          `#SingleOptionSelector-${this.sectionId}-${i}`,
        );
        if (checked && sel && sel.value !== checked.value) {
          sel.value = checked.value;
        }
      }
    },

    getSelectedOptionTuples() {
      this.syncSelectorsFromCheckedRadios();
      const tuples = [];
      const n = this.product.options?.length || 0;
      for (let i = 0; i < n; i++) {
        const sel = this.$root.querySelector(
          `#SingleOptionSelector-${this.sectionId}-${i}`,
        );
        if (sel) tuples.push({ index: `option${i + 1}`, value: sel.value });
      }
      return tuples;
    },

    syncCurrentVariant() {
      this.syncSelectorsFromCheckedRadios();
      const tuples = this.getSelectedOptionTuples();
      const variants = this.product.variants || [];
      const found = variants.find((variant) =>
        tuples.every((t, index) => variant.options?.[index] === t.value),
      );
      this.currentVariant = found || this.currentVariant || variants[0] || null;
      if (this.currentVariant?.options?.length) {
        this.currentVariant.options.forEach((value, index) => {
          const sel = this.$root.querySelector(
            `#SingleOptionSelector-${this.sectionId}-${index}`,
          );
          if (sel && sel.value !== value) {
            sel.value = value;
          }
        });
      }
      this.syncVariantInputState();
    },

    applyMasterSelect(notify = false) {
      const master = this.$root.querySelector(
        `#ProductSelect-${this.sectionId}`,
      );
      if (master && this.currentVariant) {
        master.value = String(this.currentVariant.id);
        if (notify) {
          master.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    },

    updateHistory() {
      if (!this.enableHistory || !this.currentVariant || !history.replaceState) {
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set("variant", this.currentVariant.id);
      history.replaceState({}, "", url.toString());
      document.dispatchEvent(
        new CustomEvent("variantChanged", {
          detail: { variantId: this.currentVariant.id },
        }),
      );
    },

    setPurchaseMode(mode) {
      if (mode === "subscribe" && !this.canSubscribe) return;
      this.purchaseMode = mode;
    },

    syncBundleTierSlot() {
      const total = Number(this.bundleListTotal) || 0;
      this.bundleTierSlot =
        total < 1 ? 0 : Math.min(Math.max(total, 1), 4);
    },

    bundleSubscribeUsesTiers() {
      return (
        Array.isArray(this.bundleTierPriceLabels) &&
        this.bundleTierPriceLabels.length >= 4
      );
    },

    bundleTierUnitCents() {
      if (!this.bundleSubscribeUsesTiers()) return null;
      const slot = Number(this.bundleTierSlot) || 0;
      if (slot < 1) return null;
      const idx = Math.min(Math.max(slot, 1), 4) - 1;
      const label = this.bundleTierPriceLabels[idx];
      return svPdpParseTierLabelToCents(label);
    },

    subPriceCents() {
      const tier = this.bundleTierUnitCents();
      if (this.bundleSubscribeUsesTiers() && tier != null) {
        const v = this.currentVariant;
        if (!v) return tier;
        const base = Number(v.price) || 0;
        const allocs = v.selling_plan_allocations || [];
        const id = this.selectedSellingPlanId;
        const alloc = allocs.find(
          (a) => String(a.selling_plan_id) === String(id),
        ) || allocs[0];
        const sub = alloc?.price ?? base;
        if (!base) return sub;
        return Math.round((tier / base) * sub);
      }
      const v = this.currentVariant;
      if (!v) return 0;
      const allocs = v.selling_plan_allocations || [];
      const id = this.selectedSellingPlanId;
      const alloc = allocs.find(
        (a) => String(a.selling_plan_id) === String(id),
      );
      return alloc?.price ?? allocs[0]?.price ?? 0;
    },

    subCompareCents() {
      if (this.bundleSubscribeUsesTiers() && this.bundleTierUnitCents() != null) {
        return 0;
      }
      const v = this.currentVariant;
      const sub = this.subPriceCents();
      const cmp = v?.compare_at_price;
      if (cmp && cmp > sub) return cmp;
      return 0;
    },

    onetimePriceCents() {
      const tier = this.bundleTierUnitCents();
      if (this.bundleSubscribeUsesTiers() && tier != null) return tier;
      return this.currentVariant?.price ?? 0;
    },

    onetimeCompareCents() {
      if (this.bundleSubscribeUsesTiers() && this.bundleTierUnitCents() != null) {
        return 0;
      }
      const v = this.currentVariant;
      if (!v?.compare_at_price || v.compare_at_price <= v.price) return 0;
      return v.compare_at_price;
    },

    _getBundleAlpine() {
      const br = this._bundleQtyEl?.querySelector(".sv-pdp__bundle-save");
      return br ? svPdpGetAlpineData(br) : null;
    },

    bundleSelectionUnavailable() {
      const b = this._getBundleAlpine();
      if (!b || !this.bundleListActive) return false;
      return (b.products || []).some((p) => {
        const q = b.quantities[String(p.id)] || 0;
        return q > 0 && p.available === false;
      });
    },

    submitDisabled() {
      if (this.loading) return true;
      if (this.bundleListActive) {
        return this.bundleAddBlocked() || this.bundleSelectionUnavailable();
      }
      return !this.currentVariant || !this.currentVariant.available;
    },

    addToCartButtonLabel() {
      const v = this.currentVariant;
      const sold = window.theme?.strings?.soldOut || "Sold out";
      const unavail = window.theme?.strings?.unavailable || "Unavailable";
      const def =
        String(this.atcLabel || "").trim() ||
        window.theme?.strings?.addToCart ||
        "Add to cart";
      if (this.bundleListActive) {
        if (this.bundleAddBlocked()) {
          return "Select at least one flavor";
        }
        if (this.bundleSelectionUnavailable()) return sold;
        return def;
      }
      if (!v) return unavail;
      if (!v.available) return sold;
      return def;
    },

    bundleAddBlocked() {
      return this.bundleListActive && this.bundleListTotal < 1;
    },

    hideError() {
      this.errorVisible = false;
      this.errorMessage = "";
    },

    showError(msg) {
      this.errorMessage = msg;
      this.errorVisible = true;
    },

    buildBundleCartItems(rawLines, bundleAlpine) {
      if (!rawLines || !rawLines.length) return [];
      const useBundle =
        bundleAlpine && typeof bundleAlpine.purchaseMode === "string";
      const purchaseMode = useBundle
        ? bundleAlpine.purchaseMode
        : this.purchaseMode;
      const selectedSellingPlanId = useBundle
        ? bundleAlpine.selectedSellingPlanId
        : this.selectedSellingPlanId;
      if (purchaseMode === "onetime") {
        return rawLines.map(({ id, quantity }) => ({ id, quantity }));
      }
      const planId = String(selectedSellingPlanId || "");
      if (!planId) {
        this.showError("Select a subscription plan");
        return null;
      }
      for (const line of rawLines) {
        const ids = (line.sellingPlanIds || []).map(String);
        if (!ids.includes(planId)) {
          this.showError(
            "Not all selected items support this subscription plan.",
          );
          return null;
        }
      }
      const n = Number(planId);
      return rawLines.map(({ id, quantity }) => ({
        id,
        quantity,
        selling_plan: n,
      }));
    },

    findConcentrateV2RebuyWidget() {
      const pdpRoot = this.$root.closest(".sv-pdp.sv-pdp--concentrate-v2");
      if (!pdpRoot) return null;
      return pdpRoot.querySelector("#rebuy-widget-300649");
    },

    collectConcentrateV2RebuyAddonItems() {
      const widget = this.findConcentrateV2RebuyWidget();
      if (!widget) return [];

      let checkedCount = 0;
      const items = [];

      widget.querySelectorAll(".rebuy-addon__item").forEach((itemEl) => {
        const checkbox = itemEl.querySelector(".rebuy-checkbox");
        if (!checkbox?.checked || checkbox.disabled) return;

        checkedCount += 1;

        const select = itemEl.querySelector(".rebuy-select");
        const rawId = String(select?.value || "").trim();
        if (!rawId) return;

        const parsedId = Number(rawId);
        items.push({
          id: Number.isFinite(parsedId) ? parsedId : rawId,
          quantity: 1,
        });
      });

      if (checkedCount > 0 && items.length !== checkedCount) {
        return null;
      }

      return items;
    },

    buildConcentrateV2CartItems(quantity, addonItems) {
      if (!this.currentVariant?.id) return null;

      const mainItem = {
        id: Number(this.currentVariant.id),
        quantity,
      };

      if (this.purchaseMode === "subscribe") {
        const planId = String(this.selectedSellingPlanId || "").trim();
        if (!planId) {
          this.showError("Select a subscription plan");
          return null;
        }
        const parsedPlanId = Number(planId);
        mainItem.selling_plan = Number.isFinite(parsedPlanId)
          ? parsedPlanId
          : planId;
      }

      return [mainItem, ...(addonItems || [])];
    },

    openAtcCart() {
      const smartCart = window.Rebuy?.SmartCart;
      if (typeof smartCart?.show === "function") {
        smartCart.show();
        return;
      }

      const nativeSlideCart = window.slideCart;
      if (!nativeSlideCart) return;

      const slideCartEl = document.querySelector(".slide-cart");
      const isSlideCartOpen = !!slideCartEl?.classList.contains("active");

      if (isSlideCartOpen) {
        if (typeof nativeSlideCart.getCart === "function") {
          nativeSlideCart.getCart(nativeSlideCart.buildCart);
        }
        return;
      }

      if (typeof nativeSlideCart.cartToggle === "function") {
        nativeSlideCart.cartToggle();
        return;
      }

      if (typeof nativeSlideCart.getCart === "function") {
        nativeSlideCart.getCart(nativeSlideCart.buildCart);
      }
    },

    async handleFormSubmit(e) {
      const form = e.target?.closest?.("[data-product-form]");
      if (!form || !this.$root.contains(form)) {
        return;
      }
      const info = this.$root.closest(".sv-pdp__info");
      const bundleRoot = info?.querySelector(".sv-pdp__bundle-save");
      const bundle = bundleRoot ? svPdpGetAlpineData(bundleRoot) : null;
      const raw = bundle?.cartLineItems?.() ?? [];
      const bundlePdpLocked =
        this.$root.classList.contains(
          "sv-pdp__product-section--has-bundle-save",
        );

      if (bundlePdpLocked) {
        e.preventDefault();
        e.stopPropagation();
        if (!raw.length) {
          this.showError("Select at least one flavor");
          return;
        }
        this.hideError();
        const items = this.buildBundleCartItems(raw, bundle);
        if (items == null) {
          return;
        }
        this.loading = true;
        let root = window.Shopify?.routes?.root || "/";
        if (!root.endsWith("/")) root += "/";
        const addUrl = `${root}cart/add.js`;
        try {
          const res = await fetch(addUrl, {
            method: "POST",
            body: JSON.stringify({ items }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            this.showError(
              data.description ||
                window.theme?.strings?.cartError ||
                "Could not add to cart",
            );
            return;
          }
          this.openAtcCart();
        } catch (_) {
          this.showError(
            window.theme?.strings?.cartError || "Could not add to cart",
          );
        } finally {
          this.loading = false;
        }
        return;
      }

      this.syncCurrentVariant();
      this.applyMasterSelect();

      const willHandleSubmit =
        !this.currentVariant?.available || this.ajaxEnabled;
      if (willHandleSubmit) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (!this.currentVariant?.available) {
        return;
      }
      const rebuyAddonItems = this.collectConcentrateV2RebuyAddonItems();
      if (rebuyAddonItems == null) {
        this.showError("Could not add selected add-ons");
        return;
      }
      const useRebuyAddonFallback = rebuyAddonItems.length > 0;
      if (useRebuyAddonFallback && !willHandleSubmit) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!this.ajaxEnabled && !useRebuyAddonFallback) return;
      const q = form.querySelector("[data-quantity-input]");
      const quantity = q ? Number(q.value) : 1;
      if (q && quantity <= 0) {
        this.showError(
          window.theme?.strings?.quantityMinimumMessage || "Invalid quantity",
        );
        return;
      }
      this.hideError();
      this.loading = true;
      let root = window.Shopify?.routes?.root || "/";
      if (!root.endsWith("/")) root += "/";
      const addUrl = `${root}cart/add.js`;
      if (useRebuyAddonFallback) {
        const items = this.buildConcentrateV2CartItems(quantity, rebuyAddonItems);
        if (items == null) {
          this.loading = false;
          return;
        }
        try {
          const res = await fetch(addUrl, {
            method: "POST",
            body: JSON.stringify({ items }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            this.showError(
              data.description ||
                window.theme?.strings?.cartError ||
                "Could not add to cart",
            );
            return;
          }
          this.openAtcCart();
        } catch (_) {
          this.showError(
            window.theme?.strings?.cartError || "Could not add to cart",
          );
        } finally {
          this.loading = false;
        }
        return;
      }
      const fd = new FormData(form);
      if (this.currentVariant?.id != null) {
        fd.set("id", String(this.currentVariant.id));
      }
      if (this.purchaseMode !== "subscribe") {
        fd.delete("selling_plan");
      }
      try {
        const res = await fetch(addUrl, {
          method: "POST",
          body: fd,
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          this.showError(
            data.description ||
              window.theme?.strings?.cartError ||
              "Could not add to cart",
          );
          return;
        }
        this.openAtcCart();
      } catch (_) {
        this.showError(
          window.theme?.strings?.cartError || "Could not add to cart",
        );
      } finally {
        this.loading = false;
      }
    },
  }));

  const BP = 900;

  const swiperWatchOpts = {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    roundLengths: true,
  };

  Alpine.data("svPdpGallery", () => ({
    mainSwiper: null,
    thumbSwiper: null,
    _disposeThumbMq: null,
    howToModalOpen: false,
    dialogPopupOpen: false,

    thumbDirection() {
      return window.matchMedia(`(min-width: ${BP}px)`).matches
        ? "vertical"
        : "horizontal";
    },

    bindThumbMq() {
      const mq = window.matchMedia(`(min-width: ${BP}px)`);
      const onChange = () => {
        if (!this.thumbSwiper || !this.$root?.isConnected) return;
        const next = mq.matches ? "vertical" : "horizontal";
        if (this.thumbSwiper.params.direction !== next) {
          this.thumbSwiper.changeDirection(next);
          this.thumbSwiper.update();
        }
      };
      onChange();
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },

    bumpSwipers() {
      this.thumbSwiper?.update();
      this.mainSwiper?.update();
    },

    syncModalBodyLock() {
      document.body.style.overflow =
        this.howToModalOpen || this.dialogPopupOpen ? "hidden" : "";
    },

    openHowToModal() {
      if (!this.$refs.howToVideo) return;
      this.howToModalOpen = true;
    },

    closeHowToModal() {
      this.howToModalOpen = false;
    },

    openDialogPopup() {
      this.dialogPopupOpen = true;
    },

    closeDialogPopup() {
      this.dialogPopupOpen = false;
    },

    init() {
      this.$watch("howToModalOpen", (v) => {
        this.syncModalBodyLock();
        const el = this.$refs.howToVideo;
        if (!el) return;
        if (v) {
          el.play().catch(() => {});
        } else {
          el.pause();
          el.currentTime = 0;
        }
      });
      this.$watch("dialogPopupOpen", () => {
        this.syncModalBodyLock();
      });

      if (typeof Swiper === "undefined") return;

      this._disposeThumbMq?.();
      this._disposeThumbMq = null;

      const root = this.$root;
      const mainEl = root.querySelector(".sv-pdp__main-swiper");
      if (!mainEl) return;

      const thumbEl = root.querySelector(".sv-pdp__thumbs-swiper");

      svPdpDestroySwiper(mainEl);
      svPdpDestroySwiper(thumbEl);
      this.mainSwiper = null;
      this.thumbSwiper = null;

      const slideCount = mainEl.querySelectorAll(".swiper-slide").length;
      if (slideCount === 0) return;

      if (thumbEl && slideCount > 1) {
        this.thumbSwiper = new Swiper(thumbEl, {
          ...swiperWatchOpts,
          spaceBetween: 10,
          slidesPerView: "auto",
          watchSlidesProgress: true,
          direction: this.thumbDirection(),
          centerInsufficientSlides: true,
        });

        this._disposeThumbMq = this.bindThumbMq();

        this.mainSwiper = new Swiper(mainEl, {
          ...swiperWatchOpts,
          spaceBetween: 0,
          slidesPerView: 1,
          watchOverflow: true,
          allowTouchMove: slideCount > 1,
          thumbs: {
            swiper: this.thumbSwiper,
          },
        });
      } else {
        this.mainSwiper = new Swiper(mainEl, {
          ...swiperWatchOpts,
          spaceBetween: 0,
          slidesPerView: 1,
          allowTouchMove: slideCount > 1,
        });
      }

      requestAnimationFrame(() => this.bumpSwipers());
      setTimeout(() => this.bumpSwipers(), 100);
      window.addEventListener("load", () => this.bumpSwipers(), { once: true });
    },
  }));

  Alpine.data("svPdpVideoReels", () => ({
    swiper: null,
    playingIdx: null,
    unmutedIdx: null,

    bump() {
      this.swiper?.update();
    },

    configureReelVideos() {
      this.$root.querySelectorAll(".sv-pdp__video-reel__video").forEach((v) => {
        v.loop = true;
        v.muted = true;
        v.playsInline = true;
      });
    },

    autoplayFirstReel() {
      const video = this.$root.querySelector(".sv-pdp__video-reel__video");
      if (!video) return;
      video.loop = true;
      video.muted = true;
      this.pauseAllExcept(video);
      if (!video.paused) return;
      video.play().catch(() => {});
    },

    initSwiper() {
      if (typeof Swiper === "undefined") return;

      const root = this.$root;
      const el = root.querySelector(".sv-pdp__video-reels-swiper");
      if (!el) return;

      this.configureReelVideos();
      svPdpDestroySwiper(el);
      this.swiper = null;

      const pag = root.querySelector(".sv-pdp__video-reels__pagination");
      const prev = root.querySelector(".sv-pdp__video-reels__arrow--prev");
      const next = root.querySelector(".sv-pdp__video-reels__arrow--next");
      const slideCount = el.querySelectorAll(".swiper-slide").length;
      if (slideCount === 0) return;

      this.swiper = new Swiper(el, {
        ...swiperWatchOpts,
        spaceBetween: 12,
        slidesPerView: 2.25,
        watchOverflow: true,
        breakpoints: {
          900: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
        },
        pagination:
          pag
            ? {
                el: pag,
                clickable: true,
              }
            : undefined,
        navigation:
          prev && next
            ? {
                prevEl: prev,
                nextEl: next,
              }
            : undefined,
      });

      requestAnimationFrame(() => {
        this.bump();
        this.autoplayFirstReel();
      });
      setTimeout(() => this.bump(), 100);
      window.addEventListener(
        "load",
        () => {
          this.bump();
          if (this.playingIdx == null) this.autoplayFirstReel();
        },
        { once: true },
      );
    },

    init() {
      this.$nextTick(() => {
        this.configureReelVideos();
        this.initSwiper();
        requestAnimationFrame(() => {
          if (this.playingIdx == null) this.autoplayFirstReel();
        });
      });
    },

    onSlideClick(index) {
      this.swiper?.slideTo(index);
    },

    pauseAllExcept(current) {
      this.$root.querySelectorAll(".sv-pdp__video-reel__video").forEach((v) => {
        if (v !== current) v.pause();
      });
    },

    muteAllExceptVideo(current) {
      this.$root.querySelectorAll(".sv-pdp__video-reel__video").forEach((v) => {
        if (v !== current) v.muted = true;
      });
    },

    onVideoPlay(event, index) {
      const el = event.target;
      this.playingIdx = index;
      this.pauseAllExcept(el);
      this.muteAllExceptVideo(el);
      if (el.muted) this.unmutedIdx = null;
      else this.unmutedIdx = index;
    },

    onVideoPause(event, index) {
      if (this.playingIdx === index) this.playingIdx = null;
    },

    toggleMute(event, index) {
      event.stopPropagation();
      const card = event.currentTarget.closest(".sv-pdp__video-reel-card");
      const video = card?.querySelector(".sv-pdp__video-reel__video");
      if (!video) return;

      if (video.muted) {
        this.$root.querySelectorAll(".sv-pdp__video-reel__video").forEach((v) => {
          if (v !== video) v.muted = true;
        });
        video.muted = false;
        this.unmutedIdx = index;
      } else {
        video.muted = true;
        this.unmutedIdx = null;
      }
    },

    togglePlay(event) {
      event.stopPropagation();
      const card = event.currentTarget.closest(".sv-pdp__video-reel-card");
      const video = card?.querySelector(".sv-pdp__video-reel__video");
      if (!video) return;

      if (video.paused) {
        this.pauseAllExcept(video);
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    },
  }));

  function normalizeMixIngredients(raw) {
    if (raw == null) return [];
    if (Array.isArray(raw)) {
      return raw
        .map((row) => {
          if (row == null) return null;
          if (typeof row === "string")
            return { label: row, image: "" };
          return {
            label: row.label != null ? String(row.label) : "",
            image: row.image != null ? String(row.image) : "",
          };
        })
        .filter(Boolean);
    }
    if (typeof raw === "object" && !Array.isArray(raw)) {
      if (raw.label != null || raw.image != null) {
        return [
          {
            label: raw.label != null ? String(raw.label) : "",
            image: raw.image != null ? String(raw.image) : "",
          },
        ];
      }
      return [];
    }
    if (typeof raw === "string") {
      try {
        const p = JSON.parse(raw);
        return normalizeMixIngredients(p);
      } catch {
        return [];
      }
    }
    return [];
  }

  function normalizeMixBenefits(raw) {
    if (raw == null) return [];
    if (Array.isArray(raw)) {
      return raw.map((b) => (b == null ? "" : String(b))).filter(Boolean);
    }
    if (typeof raw === "string") {
      const t = raw.trim();
      if (!t) return [];
      try {
        const p = JSON.parse(t);
        return normalizeMixBenefits(p);
      } catch {
        return [t];
      }
    }
    return [String(raw)];
  }

  Alpine.data("svPdpMixGuide", (raw) => {
    const config = raw || {};
    const emptyStatic = {
      certificationHeading: "",
      certificationBody: "",
      noArtificialHeading: "",
      noArtificialBody: "",
      footer: "",
    };
    return {
      mixDrawerOpen: false,
      mixProducts: (config.mixProducts || []).map((p) => ({
        id: p.id,
        title: p.title,
        image: p.image || "",
        serving: p.serving != null ? String(p.serving) : "",
        caffeine: p.caffeine != null ? String(p.caffeine) : "",
        calories: p.calories != null ? String(p.calories) : "",
        ingredients: normalizeMixIngredients(p.ingredients),
        benefits: normalizeMixBenefits(p.benefits),
      })),
      staticCopy: { ...emptyStatic, ...(config.staticCopy || {}) },
      selectedId: null,

      init() {
        if (this.mixProducts.length > 0) {
          this.selectedId = this.mixProducts[0].id;
        }
        this.$watch("mixDrawerOpen", (v) => {
          document.body.style.overflow = v ? "hidden" : "";
        });
      },

      mixProduct() {
        const list = this.mixProducts || [];
        if (!list.length) return null;
        const want = this.selectedId;
        return list.find((p) => p.id == want) || list[0];
      },
    };
  });

  Alpine.data("svPdpBundleSave", (config) => ({
    products: config.products || [],
    prices: config.prices || [],
    tierMatchers: Array.isArray(config.tierMatchers) ? config.tierMatchers : [],
    onetimeQtyPct: svPdpParseTierPctCsv(
      config.onetimeQtyPctCsv,
      SV_PDP_BUNDLE_ONETIME_QTY_PCT,
    ),
    quantities: {},
    purchaseMode: "onetime",
    selectedSellingPlanId: "",

    get catalogHasPlans() {
      return (this.products || []).some(
        (p) => (p.allocations || []).length > 0,
      );
    },

    productPool() {
      const all = this.products || [];
      const active = all.filter(
        (p) => (this.quantities[String(p.id)] || 0) > 0,
      );
      return active.length ? active : all;
    },

    effectiveQtyForBundling() {
      const t = this.totalQty();
      return t === 0 ? 1 : t;
    },

    previewLineProduct() {
      const ps = this.products || [];
      return ps.length ? ps[0] : null;
    },

    bundleTierFromTotalQty() {
      const t = this.effectiveQtyForBundling();
      if (t >= 4) return 4;
      if (t >= 3) return 3;
      if (t >= 2) return 2;
      return 1;
    },

    intersectAllPlanIds() {
      const pool = this.productPool();
      if (!pool.length) return [];
      let acc = null;
      for (const p of pool) {
        const ids = new Set(
          (p.allocations || []).map((a) => String(a.selling_plan_id)),
        );
        if (acc === null) acc = ids;
        else acc = new Set([...acc].filter((x) => ids.has(x)));
      }
      return acc ? [...acc].sort() : [];
    },

    planIdsForTierStrict(tier) {
      const matchers = this.tierMatchers || [];
      const needle = String(matchers[tier - 1] || "")
        .trim()
        .toLowerCase();
      if (!needle) return [];
      const pool = this.productPool();
      if (!pool.length) return [];
      let acc = null;
      for (const p of pool) {
        const matched = (p.allocations || []).filter((a) =>
          String(a.plan_name || "")
            .toLowerCase()
            .includes(needle),
        );
        const ids = new Set(matched.map((a) => String(a.selling_plan_id)));
        if (acc === null) acc = ids;
        else acc = new Set([...acc].filter((x) => ids.has(x)));
      }
      return acc ? [...acc].sort() : [];
    },

    planIdsForTier(tier) {
      let ids = this.planIdsForTierStrict(tier);
      if (ids.length) return ids;
      ids = this.intersectAllPlanIds();
      if (ids.length) return ids;
      const pool = this.productPool();
      const a = pool[0]?.allocations?.[0];
      return a ? [String(a.selling_plan_id)] : [];
    },

    get bundleCanSubscribe() {
      return this.planIdsForTier(this.bundleTierFromTotalQty()).length > 0;
    },

    normalizeBundlePlanSelection() {
      const tier = this.bundleTierFromTotalQty();
      const tierChanged =
        this._prevNormTier != null && this._prevNormTier !== tier;
      this._prevNormTier = tier;
      const strictIds = this.planIdsForTierStrict(tier);
      const candidates = this.planIdsForTier(tier);
      if (!candidates.length) {
        this.selectedSellingPlanId = "";
        if (this.purchaseMode === "subscribe") this.purchaseMode = "onetime";
        return;
      }
      const cur = String(this.selectedSellingPlanId || "");
      const curOk = candidates.some((id) => String(id) === cur);
      if (tierChanged) {
        this.selectedSellingPlanId = String(
          strictIds.length ? strictIds[0] : candidates[0],
        );
      } else if (!curOk) {
        this.selectedSellingPlanId = String(candidates[0]);
      }
      if (this.purchaseMode === "subscribe" && !this.bundleCanSubscribe) {
        this.purchaseMode = "onetime";
      }
    },

    setPurchaseMode(mode) {
      if (mode === "subscribe" && !this.bundleCanSubscribe) return;
      this.purchaseMode = mode;
      this.normalizeBundlePlanSelection();
      svPdpSyncStickyAtcPrice();
    },

    formatMoney(cents) {
      return svPdpMoney(Number(cents) || 0);
    },

    planLabelForId(planId) {
      const id = String(planId);
      for (const p of this.products || []) {
        const a = (p.allocations || []).find(
          (x) => String(x.selling_plan_id) === id,
        );
        if (a?.plan_name) return a.plan_name;
      }
      return "Subscription";
    },

    subscribeRefillLabel() {
      const id = String(this.selectedSellingPlanId || "");
      if (!id) return "";
      return svPdpRefillLabelFromPlanName(this.planLabelForId(id));
    },

    planOptions() {
      const tier = this.bundleTierFromTotalQty();
      let ids = this.planIdsForTierStrict(tier);
      if (!ids.length) {
        ids = this.planIdsForTier(tier);
      }
      return ids.map((id) => ({
        id: String(id),
        label: this.planLabelForId(id),
      }));
    },

    bundleSubscribeDiscountPct() {
      const onetime1Pack = this.sumBundleOnetimeSubtotalCents();
      const subscribe = this.sumBundleSubscribeCents();
      if (!(onetime1Pack > 0) || subscribe >= onetime1Pack) return null;
      return Math.round(((onetime1Pack - subscribe) / onetime1Pack) * 100);
    },

    bundleSubscribeBadgeLabel() {
      const p = this.bundleSubscribeDiscountPct();
      if (p == null || p <= 0) return "";
      return `SAVE ${p}%`;
    },

    bundleOnetimeDiscountPct() {
      const tier = this.bundleTierFromTotalQty();
      return this.onetimeQtyPct[tier - 1] ?? SV_PDP_BUNDLE_ONETIME_QTY_PCT[tier - 1] ?? 0;
    },

    sumBundleOnetimeSubtotalCents() {
      if (this.totalQty() === 0) {
        const p = this.previewLineProduct();
        return p ? Number(p.variantPrice) || 0 : 0;
      }
      return (this.products || []).reduce((sum, p) => {
        const q = this.quantities[String(p.id)] || 0;
        return sum + q * (Number(p.variantPrice) || 0);
      }, 0);
    },

    sumBundleOnetimeCents() {
      const sub = this.sumBundleOnetimeSubtotalCents();
      const pct = this.bundleOnetimeDiscountPct();
      return Math.round((sub * (100 - pct)) / 100);
    },

    sumBundleSubscribeSubtotalCents() {
      const planId = String(this.selectedSellingPlanId || "");
      if (this.totalQty() === 0) {
        const p = this.previewLineProduct();
        if (!p) return 0;
        const alloc = (p.allocations || []).find(
          (a) => String(a.selling_plan_id) === planId,
        );
        const unit = alloc
          ? Number(alloc.price)
          : Number(p.variantPrice) || 0;
        return unit;
      }
      return (this.products || []).reduce((sum, p) => {
        const q = this.quantities[String(p.id)] || 0;
        if (q < 1) return sum;
        const alloc = (p.allocations || []).find(
          (a) => String(a.selling_plan_id) === planId,
        );
        const unit = alloc
          ? Number(alloc.price)
          : Number(p.variantPrice) || 0;
        return sum + q * unit;
      }, 0);
    },

    sumBundleSubscribeCents() {
      const sub = this.sumBundleSubscribeSubtotalCents();
      const pct = this.bundleOnetimeDiscountPct();
      return Math.round((sub * (100 - pct)) / 100);
    },

    sumBundleOnetimeCompareCents() {
      const sub = this.sumBundleOnetimeSubtotalCents();
      const pct = this.bundleOnetimeDiscountPct();
      if (pct > 0) return sub;
      if (this.totalQty() === 0) {
        const p = this.previewLineProduct();
        return p ? Number(p.variantCompareAt) || 0 : 0;
      }
      return (this.products || []).reduce((sum, p) => {
        const q = this.quantities[String(p.id)] || 0;
        return sum + q * (Number(p.variantCompareAt) || 0);
      }, 0);
    },

    sumBundleSubscribeCompareCents() {
      return this.sumBundleOnetimeSubtotalCents();
    },

    init() {
      const next = {};
      (this.products || []).forEach((p) => {
        next[String(p.id)] = 0;
      });
      this.quantities = next;
      this.normalizeBundlePlanSelection();
      const hasPlan = this.planIdsForTier(this.bundleTierFromTotalQty()).length > 0;
      this.purchaseMode = hasPlan ? "subscribe" : "onetime";
      this.$watch(
        "quantities",
        () => {
          this.normalizeBundlePlanSelection();
          svPdpSyncStickyAtcPrice();
        },
        { deep: true },
      );
      this.$watch("purchaseMode", () => svPdpSyncStickyAtcPrice());
      this.$watch("selectedSellingPlanId", () => svPdpSyncStickyAtcPrice());
      this.$nextTick(() => {
        this.emitListQtyToForm();
        svPdpSyncStickyAtcPrice();
      });
    },

    emitListQtyToForm() {
      const info = this.$root?.closest?.(".sv-pdp__info");
      if (!info) return;
      const hasProducts = (this.products || []).length > 0;
      info.dispatchEvent(
        new CustomEvent(SV_PDP_BUNDLE_QTY, {
          bubbles: true,
          detail: {
            total: this.totalQty(),
            hasProducts,
          },
        }),
      );
    },

    totalQty() {
      return (this.products || []).reduce((sum, p) => {
        return sum + (this.quantities[String(p.id)] || 0);
      }, 0);
    },

    tierActive(n) {
      const t = this.totalQty();
      if (t < 1) return false;
      if (n === 1) return t >= 1;
      if (n === 2) return t >= 2;
      if (n === 3) return t >= 3;
      if (n === 4) return t >= 4;
      return false;
    },

    qty(id) {
      return this.quantities[String(id)] ?? 0;
    },

    productById(id) {
      const want = String(id);
      return (this.products || []).find((p) => String(p.id) === want) || null;
    },

    maxQtyForProduct(p) {
      if (!p || !p.inventoryTracked || p.inventoryPolicy === "continue") {
        return null;
      }
      const n = Number(p.inventoryQuantity);
      if (!Number.isFinite(n)) return 0;
      return Math.max(0, Math.floor(n));
    },

    canIncrement(id) {
      const p = this.productById(id);
      if (!p || p.available === false) return false;
      const max = this.maxQtyForProduct(p);
      if (max == null) return true;
      return this.qty(id) < max;
    },

    increment(id) {
      if (!this.canIncrement(id)) return;
      const k = String(id);
      this.quantities[k] = (this.quantities[k] || 0) + 1;
      this.emitListQtyToForm();
      this.normalizeBundlePlanSelection();
      svPdpSyncStickyAtcPrice();
    },

    decrement(id) {
      const k = String(id);
      const v = (this.quantities[k] || 0) - 1;
      this.quantities[k] = v < 0 ? 0 : v;
      this.emitListQtyToForm();
      this.normalizeBundlePlanSelection();
      svPdpSyncStickyAtcPrice();
    },

    cartLineItems() {
      return (this.products || [])
        .map((p) => {
          const q = this.quantities[String(p.id)] || 0;
          if (q < 1 || !p.variantId) return null;
          return {
            id: Number(p.variantId),
            quantity: q,
            sellingPlanIds: Array.isArray(p.sellingPlanIds) ? p.sellingPlanIds : [],
          };
        })
        .filter(Boolean);
    },
  }));
});
